(() => {
  const reveal = () => {
    const elements = document.querySelectorAll('.at-rv');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('in'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });

    elements.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }
})();

(() => {
  // The quick cart renders prices client-side with the theme's money format
  // ("$250.00"). Liquid-rendered prices drop trailing zeros; keep the drawer
  // consistent by stripping exact ".00" endings — never rounding real cents.
  const PRICE_SELECTOR = '.quick-cart__product-price-value, .quick-cart__product-price, .quick-cart__footer';
  const strip = (root) => {
    for (const el of root.querySelectorAll(PRICE_SELECTOR)) {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (/\d\.00(?!\d)/.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
        }
      }
    }
  };
  const init = () => {
    const cart = document.querySelector('.cart-flyout');
    if (!cart) return;
    strip(cart);
    new MutationObserver(() => strip(cart)).observe(cart, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(() => {
  // Variant changes re-render the PDP price with the raw money format
  // ("$690.00"); strip exact ".00" endings the same way the quick cart does.
  const strip = (el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/\d\.00(?!\d)/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
      }
    }
  };
  const init = () => {
    for (const price of document.querySelectorAll('.product__price')) {
      strip(price);
      new MutationObserver(() => strip(price)).observe(price, { childList: true, subtree: true, characterData: true });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* PLP: inline size quick-add — add straight to the cart drawer from the grid. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-at-add-variant]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.disabled || btn.dataset.atBusy) return;
  btn.dataset.atBusy = '1';
  var prev = btn.textContent;
  btn.textContent = '…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(btn.dataset.atAddVariant), quantity: 1 })
  }).then(function (r) {
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }).then(function () {
    btn.textContent = prev;
    btn.setAttribute('data-at-added', '');
    setTimeout(function () { btn.removeAttribute('data-at-added'); }, 2000);
    // let the theme refresh its cart state (public app hook), then open the drawer
    var drawerVisible = function () {
      var d = document.querySelector('[data-cart-drawer]');
      return !!(d && d.classList.contains('is-visible'));
    };
    var opened = false;
    var open = function () {
      if (opened) return;
      opened = true;
      if (drawerVisible()) return;
      var toggle = document.querySelector('.js-cart-drawer-toggle');
      if (toggle) toggle.click();
      // toggle semantics can misfire when aria state is desynced — verify and retry once
      setTimeout(function () {
        if (!drawerVisible()) {
          var t2 = document.querySelector('.js-cart-drawer-toggle');
          if (t2) t2.click();
        }
      }, 400);
    };
    document.addEventListener('flu:cart:updated', function h () {
      document.removeEventListener('flu:cart:updated', h);
      setTimeout(open, 150); // let the drawer re-render with the fresh state first
    });
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    setTimeout(open, 1400); // fallback if the event never fires
  }).catch(function () {
    btn.textContent = '✕';
    setTimeout(function () { btn.textContent = prev; }, 1500);
  }).finally(function () {
    delete btn.dataset.atBusy;
  });
}, true);

/* PLP: merged filter buckets — keep hidden same-label siblings in sync
   (capture phase so the theme's own change handler serialises the synced state). */
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.matches('li[data-at-merged] input[data-filter-item]')) return;
  if (input.hasAttribute('data-at-filter-sibling')) return;
  input.closest('li[data-at-merged]').querySelectorAll('input[data-at-filter-sibling]').forEach(function (sib) {
    sib.checked = input.checked;
  });
}, true);

/* Cart drawer: free-shipping nudge. Destination-scoped (country selector),
   dynamic math only for USD carts; UA destination ships free domestically. */
(function () {
  var el = document.querySelector('[data-at-shipnudge]');
  if (!el) return;
  var render = function (totalCents) {
    var country = el.dataset.country;
    var currency = el.dataset.currency;
    var threshold = Number(el.dataset.thresholdCents || 20000);
    el.removeAttribute('data-unlocked');
    if (country === 'UA') {
      el.textContent = el.dataset.msgUa;
    } else if (currency !== 'USD' || typeof totalCents !== 'number') {
      el.textContent = el.dataset.msgStatic;
    } else if (totalCents >= threshold) {
      el.textContent = el.dataset.msgUnlocked;
      el.setAttribute('data-unlocked', '');
    } else {
      var away = '$' + Math.ceil((threshold - totalCents) / 100);
      el.textContent = el.dataset.msgAway.replace('__AMT__', away);
    }
    el.hidden = false;
  };
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c.total_price); }).catch(function () {});
  document.addEventListener('flu:cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') render(cart.total_price);
    else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c.total_price); }).catch(function () {});
  });
})();
